export const OPEN_SB_BTNS = document.querySelectorAll('.open-sidebar-shopping');


export function init_sidebarShopping() {

    const 
    SB_CART = document.querySelector('#sidebar-shopping .c-cart'),
    SB_OVERLAY = document.getElementById('sidebar-shopping-overlay'),
    CLOSE_SB_BTNS = [].slice.call(document.querySelectorAll('.close-sidebar-shopping'));
        
    SB_OVERLAY ? CLOSE_SB_BTNS.push(SB_OVERLAY) : '';

    let 
        cart_items = document.querySelectorAll('#sidebar-shopping .c-cart__item'),
        sidebarTL = new TimelineLite({paused:true});
        
    if( SB_CART ){
        sidebarTL.fromTo( SB_CART, 0.6,{
            x: "0",
        },{
            x: "-100%",
            ease:Power3.easeInOut,
        })
        .fromTo( SB_OVERLAY, 0.5, {
            opacity: 0,
            display: 'none'
        },{
            opacity: 1,
            display: 'block'
        }, 0, -0.2)
        .staggerFromTo( cart_items, 0.32, {
            opacity: 0,
            y: "40px"
        },{
            ease:Power1.easeInOut,
            opacity: 1,
            y: 0,
        }, 0.06, 0.3 );
    }

    if( OPEN_SB_BTNS.length ){
        for( let i=0, len = OPEN_SB_BTNS.length; i < len; i++){
            OPEN_SB_BTNS[i].addEventListener('click', openSidebar);
        }
    }
    if( CLOSE_SB_BTNS.length ){
        for( let i=0, len = CLOSE_SB_BTNS.length; i < len; i++){
            CLOSE_SB_BTNS[i].addEventListener('click', (e) =>{ closeSidebar(e) });
        }
    }

    document.addEventListener('keydown', (e) => {
        e = e || window.event;
        if (e.keyCode == 27) {
            closeSidebar();
        }
    });

    function openSidebar () {
        document.documentElement.classList.add('cart-open');
        sidebarTL.play().timeScale(1);
    }
    function closeSidebar (e) {
        e.preventDefault()
        sidebarTL.reverse().timeScale(1.3);
        document.documentElement.classList.remove('cart-open');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/sidebar-shopping.js